import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import router from '../router/index'

let util = {}
const env = 'production'

util.title = function (title) {
  title = title || '快招聘'
  window.document.title = title
}

const ajaxUrl = env === 'development' ? 'http://localhost:9081/' : env === 'production' ? 'https://s.bysjy.com.cn/' : 'https://s.bysjy.com.cn/'

util.ajax = axios.create({
  baseURL: ajaxUrl,
  timeout: 30000
})

// 静态资源的加速路径
util.cdn = env === 'development' ? '': 'https://o.bysjy.com.cn/kzp_dist/kzp'

util.post = function (url, data, params, callback, silent) {
  let token = ''
  if (!!sessionStorage.getItem('kzp_key') && !!sessionStorage.getItem(sessionStorage.getItem('kzp_key'))) {
    token = JSON.parse(sessionStorage.getItem(sessionStorage.getItem('kzp_key'))).token
  }

  let axios_url = ajaxUrl + util.addSign(url) + '&token=' + token + util.is_debug
  return axios.post(axios_url, qs.stringify(data)).then((response) => {
    const {data} = response
    const {code, msg} = data || {}

    if (code !== 1 && silent === undefined) {
      util.errorFun(msg, params)
    }
    callback ? callback(data) : null
    return data
  }, function (error) {
    const {response} = error
    if (!response) return
    if ([401].indexOf(response.status) >= 0) {

    }
    if (response.hasOwnProperty('data')) {
      return Promise.reject(response.data)
    } else {
      return Promise.reject(response)
    }
  })
}

util.get = function (url, params, all, callback) {
  let token = ''
  if (!!sessionStorage.getItem('kzp_key') && !!sessionStorage.getItem(sessionStorage.getItem('kzp_key'))) {
    token = JSON.parse(sessionStorage.getItem(sessionStorage.getItem('kzp_key'))).token
  }

  let get_url = all ? url: ajaxUrl + util.addSign(url) + util.is_debug
  if (params && !params.token){
    get_url += '&token=' + token
  }
  return axios.get(get_url, {
    params: params
  }).then((response) => {
    const {data} = response

    callback ? callback(data) : null
    return data
  }, function (error) {
    const {response} = error
    if (!response) return
    if ([401].indexOf(response.status) >= 0) {

    }
    if (response.hasOwnProperty('data')) {
      return Promise.reject(response.data)
    } else {
      return Promise.reject(response)
    }
  })
}

util.errorFun = function (msg, params) {
  if (msg && msg.indexOf('请登录') >= 0) {
    // Vue.$vux.confirm.show({
    //   content: msg,
    //   title: '点击确定去登录',
    //   onConfirm: () => {
    //     router.push({path: '/login?self=1&back=' + encodeURIComponent(window.location.pathname)})
    //   }
    // })
    /*
    1. 跳转云就业获取openid
    2. 拿到openid去登陆
    */

   let has_union_id = localStorage.getItem('has_union_id')
   const host = window.location.host

   let back = window.location.pathname
   if (util.getQueryString('back_url')){
     back += '?back_url=' + util.getQueryString('back_url')
   }

   let return_url = 'http://' + host + '/login_openid?back=' + encodeURIComponent(back) + '&v=' + (new Date()).getTime()
   location.href = "https://m.bysjy.com.cn/student/kzp/bind.html?token=yunyan1536161856" +
                    (has_union_id ? '&silent=true': '') + "&return_url=" + encodeURIComponent(util.addToken(return_url))
  } else if (!params) {
    Vue.$vux.toast.show({
      text: msg || '操作失败'
    })
  }
}

util.ajax.interceptors.response.use(function (response) {
  const {
    data
  } = response

  const {
    code, msg
  } = data || {}

  if (code !== 1) {
    util.errorFun(msg, true)
  }

  return data
}, function (error) {
  const {response} = error
  if (response && [401].indexOf(response.status) >= 0) {

  }
  if (response.hasOwnProperty('data')) {
    return Promise.reject(response.data)
  } else {
    return Promise.reject(response)
  }
})

util.arrayInArray = function (parentArray, sunArray) {
  if (!(parentArray instanceof Array) || !(sunArray instanceof Array)) return false
  // if (parentArray.length < sunArray.length) return false;
  for (var i = 0, len = sunArray.length; i < len; i++) {
    if (parentArray.indexOf(sunArray[i]) === -1) {
      return false
    } else {
      return true
    }
  }
  return true
}

util.showThisRoute = function (needAccess, currentAccess) {
  if (typeof needAccess === 'object' && Array.isArray(needAccess)) {
    return util.arrayInArray(needAccess, currentAccess)
  } else {
    return needAccess === currentAccess
  }
}

util.handleTitle = function (vm, item) {
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n)
  } else {
    return item.title
  }
}

util.formatDate = function (time, format) {
  let testDate = new Date(time)
  let o =
    {
      'M+': testDate.getMonth() + 1,
      'd+': testDate.getDate(),
      'h+': testDate.getHours(),
      'm+': testDate.getMinutes(),
      's+': testDate.getSeconds(),
      'q+': Math.floor((testDate.getMonth() + 3) / 3),
      'S': testDate.getMilliseconds()
    }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (testDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

util.getUrlParam = function (paraName) {
  var url = document.location.toString()
  var arrObj = url.split('?')

  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&')
    var arr
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')

      if (arr != null && arr[0] === paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

util.getQueryString = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return ''
}

util.checkSchool = function (target_url) {
  var timestamp = new Date().getTime()
  var current_url = window.location.href
  var check_school_url = target_url || 'http://m.bysjy.com.cn/student/chance/selectschool.html?token=yunyan1536161856'
  location.href = check_school_url + '&return_url=' + current_url + '?&t=' + timestamp
}

util.getTranslate = function (node, sty) {
  var translates = document.defaultView.getComputedStyle(node, null).transform.substring(7)
  var result = translates.match(/\(([^)]*)\)/)// 正则()内容
  var matrix = result ? result[1].split(',') : translates.split(',')
  if (sty === 'x' || sty === undefined) {
    return matrix.length > 6 ? parseFloat(matrix[12]) : parseFloat(matrix[4])
  } else if (sty === 'y') {
    return matrix.length > 6 ? parseFloat(matrix[13]) : parseFloat(matrix[5])
  } else if (sty === 'z') {
    return matrix.length > 6 ? parseFloat(matrix[14]) : 0
  } else if (sty === 'rotate') {
    return matrix.length > 6 ? this.getRotate([parseFloat(matrix[0]), parseFloat(matrix[1]), parseFloat(matrix[4]), parseFloat(matrix[5])]) : this.getRotate(matrix)
  }
}

util.getRotate = function (matrix) {
  var aa = Math.round(180 * Math.asin(matrix[0]) / Math.PI)
  var bb = Math.round(180 * Math.acos(matrix[1]) / Math.PI)
  var cc = Math.round(180 * Math.asin(matrix[2]) / Math.PI)
  var dd = Math.round(180 * Math.acos(matrix[3]) / Math.PI)
  var deg = 0
  if (aa === bb || -aa === bb) {
    deg = dd
  } else if (-aa + bb === 180) {
    deg = 180 + cc
  } else if (aa + bb === 180) {
    deg = 360 - cc || 360 - dd
  }
  return deg >= 360 ? 0 : deg
}

util.overscroll = function (el) {
  var _self = this
  el.addEventListener('touchstart', function (e) {
    console.log(e)
    _self.popupTransform.transformPosition.startX = e.touches[0].pageX
    _self.popupTransform.transformPosition.startY = e.touches[0].pageY
  })
  el.addEventListener('touchmove', function (e) {
    let endX = e.touches[0].pageX
    let endY = e.touches[0].pageY
    console.log('endY' + endY)
    let distanceX = endX - _self.popupTransform.transformPosition.startX
    let distanceY = endY - _self.popupTransform.transformPosition.startY

    console.log('distanceY' + distanceY)
    if (Math.abs(distanceX) > Math.abs(distanceY) && distanceX > 0) {
      console.log('往右滑动')
    } else if (Math.abs(distanceX) > Math.abs(distanceY) && distanceX < 0) {
      console.log('往左滑动')
    } else if (Math.abs(distanceX) < Math.abs(distanceY) && distanceY < 0) {
      console.log('往上滑动')
    } else if (Math.abs(distanceX) < Math.abs(distanceY) && distanceY > 0) {
      console.log('往下滑动')
    } else {
      console.log('点击未滑动')
    }
  })
}

// 微信事件、方法处理
util.jweixin = function (params, wechat, fn) {
  util.getSignPackage(params, function (sign) {
    util.bindWX(sign, wechat, function (wx) {
      fn(wx)
    })
  })
}

util.isWeiXin = function () {
  if (!!window._openid) {
    return true
  }
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

util.getSignPackage = function (params, callback) {
  if (util.isWeiXin()) {
    if (util.getQueryString('t_') === '1') {
      return
    }
    util.ajax.get('index.php?r=kzp/ajax_sign_package', {
      params: params
    }).then(function (result) {
      if (result.code === 1) {
        callback(result.data)
      }
    })
  }
}

util.bindWX = function (sign, wechat, fn) {
  let wx = wechat
  wx.config({
    appId: sign.appId,
    timestamp: sign.timestamp,
    nonceStr: sign.nonceStr,
    signature: sign.signature,
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'hideMenuItems',
      'showMenuItems',
      'getLocation',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage'
    ]
  })
  wx.ready(function () {
    console.log('bind-ready')

    wx.checkJsApi({
      jsApiList: [
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage'
      ],
      success: function (res) {
        //如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        if (res.errMsg == 'checkJsApi:ok') {
          if (!!fn) {
            fn(wx)
          }
        } else {
          alert('您当前的微信版本过低')
        }
      }
    })
  })
}

util.getLocation = function(wx, callback){
  wx.getLocation({
    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    success: function (res) {
      callback ? callback(res): null
    },
    fail: function(res){
      console.log('获取地址失败:', res)
    }
  })
}

util.wxShare = function (wx, share) {
  // 监听“分享给朋友”
  wx.onMenuShareAppMessage({
    title: share.title,
    desc: share.desc,
    link: share.link,
    imgUrl: share.imgUrl
  })

  //监听“分享到朋友圈”
  wx.onMenuShareTimeline({
    title: share.title,
    link: share.link,
    imgUrl: share.imgUrl
  })

  //监听“分享到QQ”
  wx.onMenuShareQQ({
    title: share.title,
    desc: share.desc ? share.desc : share.title,
    link: share.link,
    imgUrl: share.imgUrl,
    fail: function (res) {
      alert('分享到QQ失败' + JSON.stringify(res))
      //console.log(JSON.stringify(res) +'onMenuShareQQ');
    }
  })

  //监听“分享到微博”
  wx.onMenuShareWeibo({
    title: share.title,
    desc: share.desc,
    link: share.link,
    imgUrl: share.imgUrl
  })
}

//批量隐藏功能按钮接口
util.hideWXMenu = function (wx) {
  wx.hideMenuItems({
    menuList: [
      /*'menuItem:share:appMessage',   //发送给朋友,
       'menuItem:share:timeline',     //分享到朋友圈
       */
      'menuItem:share:qq',           //分享到QQ
      'menuItem:share:weiboApp',     //分享到Weibo
      'menuItem:share:facebook',     //分享到facebook
      'menuItem:share:QZone'         //分享到QQ空间
    ]
  })
}

// 获取设备信息
util.getDeviceType = function () {
  let device = {}
  let ua = navigator.userAgent

  let android = ua.match(/(Android);?[\s\/]+([\d.]+)?/)
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/)
  let ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/)
  let iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/)

  device.ios = device.android = device.iphone = device.ipad = device.androidChrome = false

  // Android
  if (android) {
    device.os = 'android'
    device.osVersion = android[2]
    device.android = true
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios'
    device.ios = true
  }
  // iOS
  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.')
    device.iphone = true
  }
  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.')
    device.ipad = true
  }
  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null
    device.iphone = true
  }
  // iOS 8+ changed UA
  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0]
    }
  }

  // Webview
  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i)

  // Minimal UI
  if (device.os && device.os === 'ios') {
    let osVersionArr = device.osVersion.split('.')
    device.minimalUi = !device.webView &&
      (ipod || iphone) &&
      (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
      $('meta[name="viewport"]').length > 0 && $('meta[name="viewport"]').attr('content').indexOf('minimal-ui') >= 0
  }

  // Check for status bar and fullscreen app mode
  let windowWidth = $(window).width()
  let windowHeight = $(window).height()
  device.statusBar = false
  if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
    device.statusBar = true
  } else {
    device.statusBar = false
  }

  // Classes
  let classNames = []

  // Pixel Ratio
  device.pixelRatio = window.devicePixelRatio || 1
  classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio))
  if (device.pixelRatio >= 2) {
    classNames.push('retina')
  }

  // OS classes
  if (device.os) {
    classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'))
    if (device.os === 'ios') {
      let major = parseInt(device.osVersion.split('.')[0], 10)
      for (let i = major - 1; i >= 6; i--) {
        classNames.push('ios-gt-' + i)
      }
    }

  }
  // Status bar classes
  if (device.statusBar) {
    classNames.push('with-statusbar-overlay')
  } else {
    $('html').removeClass('with-statusbar-overlay')
  }

  // Add html classes
  //if (classNames.length > 0) $('html').addClass(classNames.join(' '));

  // Export object
  return device
}

// 加上token
util.addToken = function (url) {
  var link = url + (url.indexOf('?') > 0 ? '&' : '?')

  let token = ''
  if (!!sessionStorage.getItem('kzp_key') && !!sessionStorage.getItem(sessionStorage.getItem('kzp_key'))) {
    token = JSON.parse(sessionStorage.getItem(sessionStorage.getItem('kzp_key'))).token
  }

  token = token ? token : util.getQueryString('token')

  link += token ? ('token=' + token) : ''

  return link
}

// 存储sign
util.cacheSign = function (sign) {
  // sign 的过期时间
  VueCookies.set('sign', sign, 86400 * 30)
}
// 加上sign
util.addSign = function (url) {
  url += url.indexOf('?') > 0 ? '' : '?'
  const sign = VueCookies.get('sign')
  sign ? util.cacheSign(sign): null
  return url + '&sign=' + sign
}

util.isArrayFn = function (value) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(value)
  } else {
    return Object.prototype.toString.call(value) === '[object Array]'
  }
}

util.today = function () {
  let now = new Date()
  let year = now.getFullYear()
  let cmonth = now.getMonth() + 1
  let day = now.getDate()
  if (cmonth < 10) cmonth = '0' + cmonth
  if (day < 10) day = '0' + day
  const today = year + '-' + cmonth + '-' + day
  return {
    year,
    month: cmonth,
    day,
    today
  }
}

util.addBack = function(url){
  url += url.indexOf('?') > 0 ? '' : '?'
  return url + '&back=' + encodeURIComponent(window.location.pathname)
}

util.is_full = function (need, obj) {
  for (let key in need) {
    if (!obj[key]) {
      Vue.$vux.toast.show({
        text: need[key][0] + '必填'
      })
      return false
    }
  }

  return true
}

util.formatTime = function (val, str, str1) {
  if (!val) return undefined
  var symbol = str || /\/|\./g
  var symbol1 = str1 || '-'
  var back = val.replace(symbol, symbol1)
  if (back.length == 7) {
    back += '-01'
  }
  return back
}

util.browser = {
  versions: function () {
    let u = navigator.userAgent
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,//火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') === -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) === ' qq' //是否QQ
    }
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

util.imgUrl = function(sign){
  return ajaxUrl + 'index.php?r=kzp_user/ajax_img_code&sign=' + sign
}

// 更新定位城市
var timerUpdate = null
var maxUpdate = 0
util.updateCityStart = function(){
  maxUpdate++
  if(maxUpdate > 3){
    maxUpdate = 0
    return
  }
  timerUpdate = setTimeout(util.updateCity, 3000)
}
util.updateCity = function(param){
  clearTimeout(timerUpdate)
  const city = param || localStorage.getItem('cacheCity')
  const current_city = localStorage.getItem('current_city')
  // city 为空  ||  当前城市没变
  if(!city){
    util.updateCityStart()
    return
  }
  if(city == current_city){
    return
  }

  maxUpdate = 0
  util.get('index.php?r=kzp_user/ajax_update_city', {city}).then(function (res) {
      if(res.code == 1){
        localStorage.setItem('current_city', city)
      }
  })

}

// 获取用户的 云就业openid
util.getOpenId = function(back, no_silent){

  const host = window.location.host
  let return_url = 'http://' + host + '/get_openid?back=' + encodeURIComponent(back)

  location.href = "https://m.bysjy.com.cn/student/kzp/bind.html?token=yunyan1536161856&return_url=" + encodeURIComponent(util.addToken(return_url)) +
   (no_silent ? '': "&silent=true")
}

util.test = function(){
  const is_debug = util.getQueryString('is_debug')
  if(is_debug && is_debug == 'cancel'){
    VueCookies.set('is_debug', '', 0)
  }else if(is_debug){
    VueCookies.set('is_debug', 'is_debug=weyon', 86400)
  }
  util.is_debug = "&" + VueCookies.get('is_debug')
}
util.test()


export default util



// WEBPACK FOOTER //
// ./src/libs/util.js